import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import * as scriptEditorActions from '../../../../../redux/scriptEditor/actions.scriptEditor';

class SourceInfo extends React.Component {

    // todo: move to service
    highlightLine = (debugInfo, type) => {
        const { highlightLine, project } = this.props;
        highlightLine({
            scriptName: debugInfo.file,
            lineNumber: debugInfo.line,
            lineType: type,
            project,
        });
    }

    highlightRequestLine = () => {
        const { info } = this.props;
        this.highlightLine(info, 'intent');
    }

    highlightResponseLine = () => {
        const { info } = this.props;
        this.highlightLine(info, 'response');
    }

    render() {
        const { info, type } = this.props;
        const unrecognised = !info?.file;

        return (info && info.file) ?
            <div
                className={`source-info ${type}-type`}
                onClick={type === 'intent' ? this.highlightRequestLine : this.highlightResponseLine}>
                <div
                    className={`${type === 'intent' ? 'p' : 'r'}-Loc_link`}>
                    {type === 'intent' ?
                        <i className="icon icon-alan-input-sign" /> :
                        <i className="icon icon-alan-output-sign" />}
                    <div className={`${type === 'intent' ? 'p' : 'r'}-Loc_wrapper`} title={`${info.file}:${info.line}`}>
                        <span className="loc_link">{info.file}</span>
                    </div>
                    <span className="loc_num">{` :${info.line}`}</span>
                </div>
            </div> :
            <>
            </>;
    }
}


function mapStateToProps({ projectsInfo }) {
    return {
        project: projectsInfo.currentProject,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        highlightLine: (param) => dispatch(scriptEditorActions.highlightLine(param)),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(SourceInfo);

